import { Injectable } from '@angular/core';
import { PermissionCheck, hasRequiredPermission } from '@cawita/core-front/auth';
import { CwtStore } from '@cawita/core-front/state';
import { Client, ClientAccess, User } from '@shared/models';
import { ClientAccessAPI } from '@shared/services/client-access.api';
import { finalize, map, of, tap } from 'rxjs';

export type ClientState = {
    activeClient: Client;
    activeAccess: ClientAccess;
}

@Injectable({ providedIn: 'root' })
export class ClientStore extends CwtStore<ClientState> {
    constructor(
        protected clientAccessApi: ClientAccessAPI
    ) {
        super({
            activeClient: null,
            activeAccess: null,
            initialized: false,
            loading: false
        });
    }

    public init(user: User) {
        this.setInitialized(false);
        this.setLoading(true);
        return this.clientAccessApi.getMineClientAccesses().pipe(
            map(accesses => this._getClientAndAccessToUse(accesses)),
            tap({
                next: ([client, access]) => this.setState({ activeAccess: access, activeClient: client, initialized: true, loading: false, }),
                error: () => this.setState({ activeAccess: null, activeClient: null, initialized: true, loading: false }),
            })
        );
    }

    public clear() {
        this.setState({
            activeClient: null,
            activeAccess: null,
            initialized: false,
            loading: false
        });
    }

    public hasRequiredPermissions(permissions: string | PermissionCheck[]) {
        const { activeAccess } = this.getValue();
        return hasRequiredPermission(activeAccess?.permissions ?? [], permissions);
    }

    private _getClientAndAccessToUse(accesses: ClientAccess[]): [client: Client, access: ClientAccess] {
        if (!accesses?.length) return [null, null];
        const firstAccess = accesses[0];
        return [firstAccess.client, firstAccess];
    }
}